import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// Route classifier — decides which auth token to attach.
function classifyRoute(url) {
  const u = url || "";
  // Customer routes (Module 3)
  if (
    u.startsWith("/auth/customer") ||
    u === "/auth/change-customer-password" ||
    u.startsWith("/quotes") ||
    u.startsWith("/bookings") ||
    u.startsWith("/payments")
  ) {
    return "customer";
  }
  // Admin routes (Module 1/2)
  if (
    u.startsWith("/admin/") ||
    u === "/admin" ||
    u === "/auth/login" ||
    u === "/auth/change-password" ||
    u === "/auth/me"
  ) {
    return "admin";
  }
  return "public";
}

client.interceptors.request.use((config) => {
  const kind = classifyRoute(config.url || "");
  let token = null;
  if (kind === "admin") {
    token = localStorage.getItem("tk_admin_token");
  } else if (kind === "customer") {
    token = localStorage.getItem("tk_customer_token");
  } else {
    // Public — no token needed, but attach a token if one is present so admin
    // (or customer) can PATCH/POST to endpoints that accept optional auth later.
    token =
      localStorage.getItem("tk_customer_token") ||
      localStorage.getItem("tk_admin_token");
  }
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const path = window.location.pathname || "";
    if (status === 401) {
      // Auth-free admin pages handle their own 401s (bad/expired reset tokens)
      const authFreeAdmin = ["/admin/login", "/admin/recovery", "/admin/forgot-password", "/admin/reset-password"];
      const authFreeAccount = ["/account/login", "/account/register", "/account/forgot-password", "/account/reset-password"];
      if (path.startsWith("/admin") && !authFreeAdmin.some((p) => path.startsWith(p))) {
        localStorage.removeItem("tk_admin_token");
        window.location.href = "/admin/login";
      } else if (path.startsWith("/account") && !authFreeAccount.some((p) => path.startsWith(p))) {
        localStorage.removeItem("tk_customer_token");
        localStorage.removeItem("tk_customer_info");
        window.location.href = "/account/login";
      }
    }
    return Promise.reject(err);
  }
);

export default client;

export const imageUrl = (imageId) =>
  imageId ? `${API}/images/${imageId}` : null;

// Safe extractor for API error detail (handles Pydantic v2 array-of-objects).
export const errMsg = (err, fallback = "Something went wrong") => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string" && d) return d;
  if (Array.isArray(d) && d.length > 0) {
    const first = d[0];
    if (typeof first === "string") return first;
    if (first && typeof first === "object" && typeof first.msg === "string") {
      return first.msg;
    }
  }
  return fallback;
};
